document.addEventListener('DOMContentLoaded', formHandling);

function formHandling()
{
    handleFormSubmitWithRedirect("newsletteranmeldung_");
    handleFormSubmitWithRedirect("newsletternachqualifizierung_");
}

function handleFormSubmitWithRedirect(formId)
{
    const form = document.querySelector("#" + formId);
    const form_error = document.querySelector("#" + formId + "error");
    const form_loading = document.querySelector("#" + formId + "loading");
    if(!form)
    {
        return;
    }
    form.addEventListener("submit", (event) => {
        event.preventDefault();
        const clicked_button = document.activeElement;

        addClass(form_error, "hidden");
        removeClass(form_loading, "hidden");
        if(form_loading)
        {
            addClass(clicked_button, "hidden");
        }
        const apiUrl = form.getAttribute("data-api-url");
        const redirectUrl = form.getAttribute("data-redirect");
        const formData = new FormData(form);

        fetch(apiUrl, {
            method: "POST",
            body: formData,
        }).then(
            result => {
                if(!result.ok)
                {
                    throw new Error(result.statusText);
                }
                if(redirectUrl)
                {
                    location.href = redirectUrl
                }
            }
        ).catch(
            (e) => {
                addClass(form_loading, "hidden");
                removeClass(clicked_button, "hidden");
                removeClass(form_error, "hidden");
            }
        );
    });

}

const addClass = (element, className) => element?.classList.add(className);
const removeClass = (element, className) => element?.classList.remove(className);
